import { createAuthClient } from "better-auth/react";
import { createContext, useContext, useState } from "react";

export const authClient = createAuthClient({});

export const useAuthClient = () => {
	return useContext(AuthClientContext);
};

const AuthClientContext = createContext<AuthClientContextType>(null);

export type AuthClientContextType = ReturnType<typeof createAuthClient>;

export const AuthClientProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [client] = useState(() => createAuthClient());

	return <AuthClientContext.Provider value={client}>{children}</AuthClientContext.Provider>;
};
